import React from 'react';

const Benefits = () => (
	<div className="container main">
		<h2>Avantages</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-12">
				<h4>Quels sont les avantages de l’utilisation du portail mondial sur les rappels de produits ?</h4>
				<p>
					Pour les <strong>autorités publiques</strong>, le portail présente de nombreux avantages, notamment celui d’améliorer le partage d’informations sur les rappels de produits
					au niveau mondial en les regroupant en un lieu unique et en temps opportun. En outre, les autorités peuvent suivre les tendances émergentes,
					au moyen en particulier de <a href="https://globalrecalls.oecd.org/#/dashboard?lang=fr">tableaux de bord interactifs</a>, et détecter les risques pour les consommateurs relevant de leur compétence qui pourraient exiger une intervention. En raison de la mondialisation des chaînes d’approvisionnement et de l’augmentation des achats en ligne effectués auprès de commerçants étrangers, il peut s’avérer nécessaire de rappeler un produit dans plusieurs pays ou territoires en cas de problème de sécurité.
				</p>
				<p>
					Le portail utilise une taxonomie de produits commune et s’intègre facilement aux bases de données nationales dédiées aux rappels de produits.
					Une <a href="https://globalrecalls.oecd.org/#/admin?lang=fr">API d’exportation</a> est également à la disposition des autorités publiques et des particuliers qui souhaitent examiner en détail les données du portail.
				</p>
				<p>
					Pour les <strong>entreprises</strong>, et notamment les <strong>fabricants de produits</strong>, le portail fournit des informations susceptibles de leur permettre
					d’agir plus rapidement face à des problèmes de sécurité, réduisant ainsi le nombre d’incidents sources de blessures et les coûts qui y sont associés.
					<strong>Les entreprises qui importent des produits de consommation peuvent également tirer parti du portail en vérifiant si des produits font l’objet d’un rappel dans d’autres pays ou territoires</strong>. En consultant le portail, les <strong>détaillants et les places de marché en ligne</strong> pourront également agir plus rapidement pour retirer les produits dangereux de la vente.
				</p>
				<p>Le portail, qui est accessible en version mobile, permet également aux <strong>consommateurs</strong> désireux de comparer les produits de vérifier facilement et à tout moment si un produit fait l’objet d’un rappel.</p>
			</div>
		</div>
	</div>
);

export default Benefits;



// WEBPACK FOOTER //
// ./src/views/static/fr/benefits.js